// Static data for Vickie Daignault's portfolio

export const HERO_IMAGE =
    "https://customer-assets.emergentagent.com/job_casting-ready-1/artifacts/cun4u8ip_Vickie%20Daignault%20Headshot%202.jpeg";

export const ALT_HEADSHOT =
    "https://customer-assets.emergentagent.com/job_casting-ready-1/artifacts/tv2l6gkp_VickieDaignault.JPG";

export const PRODUCTION_PHOTO =
    "https://customer-assets.emergentagent.com/job_casting-ready-1/artifacts/a2oxosv8_IMG_2565.jpeg";

export const ACTING_RESUME_URL =
    "https://customer-assets.emergentagent.com/job_casting-ready-1/artifacts/u0rlmimq_Vickie%20Daignault%20Resume.pdf";

export const DIRECTING_RESUME_URL =
    "https://customer-assets.emergentagent.com/job_casting-ready-1/artifacts/7rk1kom3_Vickie%20Daignault%20Directing%20Resume.pdf";

export const SEED_GALLERY = [
    {
        url: ALT_HEADSHOT,
        caption: "Headshot · Outdoor Portrait",
    },
    {
        url: PRODUCTION_PHOTO,
        caption: "Backstage · Pre-show",
    },
    {
        url: "https://images.unsplash.com/photo-1771911654347-b1b506fa40f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
        caption: "Stage · Performance",
    },
];

export const BIO_PARAGRAPHS = [
    "Hi, I'm Vickie Daignault, an actor and director. No time to watch the video? Here's the TL;DR version:",
    "I play women who are…complicated. Clinging to power, clinging to youth. They're strong, wrong and really know how to put the dysfunction into parenting. No surprise, they're often (okay, always) unlucky in love.",
    "I'm also a director, working across professional and educational theatre.",
    "I've worked with people you know. Now I'd like to work with you.",
];

export const BILLING = {
    name: "Vickie Daignault",
    tagline: "Actor • Director",
    union: "AEA · SAG-AFTRA",
    height: "5'7\"",
    voice: "Mezzo · D3–Bb5",
    location: "Chicago / Sarasota / NYC",
    email: "vickiedaignault@gmail.com",
    phone: "773.255.2342",
};

export const ACTING_CREDITS = [
    {
        production: "The Year of Magical Thinking",
        role: "Lead",
        company: "Stageworks Theatre",
        director: "",
        note: "Winner — Outstanding Performance by a Lead Actress",
    },
    {
        production: "Hats!",
        role: "Baroness / U/S Lead",
        company: "Royal George Theatre",
        director: "Lynne Taylor-Corbett",
    },
    {
        production: "The Sound Inside",
        role: "Bella",
        company: "Urbanite Theatre",
    },
    {
        production: "The Immigrant",
        role: "Ima",
        company: "Sarasota Jewish Theatre",
    },
    {
        production: "Ugly Lies the Bone",
        role: "Voice / Mom",
        company: "Florida Studio Theatre",
    },
    {
        production: "Between Riverside and Crazy",
        role: "Det. Audrey O'Connor",
        company: "American Stage",
    },
    {
        production: "Silent Sky",
        role: "Annie",
        company: "Stageworks Theatre",
    },
    {
        production: "Women Laughing Alone with Salad",
        role: "Sandy",
        company: "Urbanite Theatre",
    },
    {
        production: "Dixie Swim Club",
        role: "Sheree (w/ Morgan Fairchild)",
        company: "Alhambra Theatre",
    },
    {
        production: "Good People",
        role: "Jean",
        company: "American Stage",
        note: "Winner — Best Ensemble · Featured Actress Nominee",
    },
    {
        production: "The Odd Couple",
        role: "Vinnie",
        company: "Theatre Building Chicago",
    },
    {
        production: "Time-Step",
        role: "Lillian",
        company: "Key City Public Theatre",
    },
    {
        production: "To Kill a Mockingbird",
        role: "Miss Maudie / Gilmer",
        company: "NC Shakespeare Festival",
    },
    {
        production: "A Christmas Carol",
        role: "Hattie",
        company: "Pegasus Players",
    },
    {
        production: "Kindertransport",
        role: "Helga",
        company: "Apple Tree Theatre",
    },
];

export const DIRECTING_CREDITS = [
    {
        section: "Professional",
        items: [
            {
                production: "Year of Extraordinary Travel",
                writer: "Becca McCoy",
                company: "Studio Grand Central",
                note: "Upcoming",
            },
            {
                production: "Tennessee Psalms",
                writer: "Angela Bond",
                company: "SaraSolo",
            },
            {
                production: "A Light Supper at the End of the World",
                writer: "Matt Cowley",
                company: "New College Black Box · Theatre Week 2020",
            },
            {
                production: "Love v. Death",
                writer: "Tom Sivak",
                company: "Palladium Side Door Cabaret, St. Petersburg",
            },
            {
                production: "Immurement",
                writer: "David L. Williams",
                company: "Theatre Odyssey, Sarasota",
            },
            {
                production: "Death & Other Errors in Judgement",
                writer: "Matt Cowley",
                company: "USF St. Petersburg · Theatre Week 2019",
            },
            {
                production: "Overtones",
                writer: "Alice Gerstenberg",
                company: "New Branch Theatre Co. · Majestic Midway, Chicago",
            },
            {
                production: "Blade",
                writer: "Yvette Nolan",
                company: "3 Women At Once · Act One Studios, Chicago",
            },
        ],
    },
    {
        section: "Educational",
        items: [
            {
                production: "Girls Just Want to Have Fun",
                writer: "Devised",
                company: "Children's Theatre of Charlotte",
            },
            {
                production: "Story Theatre",
                writer: "Paul Sills",
                company: "Children's Theatre of Charlotte",
            },
            {
                production: "The Dragon of Nitt",
                writer: "Phil Grecian",
                company: "Children's Theatre of Charlotte",
            },
            {
                production: "How to Eat Like a Child",
                writer: "Delia Ephron",
                company: "Apple Tree Theatre",
            },
            {
                production: "Joyful Noise",
                writer: "Paul Fleischman",
                company: "Readers Theatre Workshop, NY",
            },
        ],
    },
];

export const TRAINING = [
    {
        label: "BFA Drama",
        body: "University of North Carolina School of the Arts — Malcolm Morrison, Tunc Yalman, Cigdem Onat, James Dodding, Bob Francisconi",
    },
    {
        label: "Directing",
        body: "David Cromer (Tony Award · The Band's Visit) — Act One Studios · DirectorsLabChicago (2008–2014)",
    },
    {
        label: "On Camera",
        body: "Greg Apps (Self-Taping School) · Christine Horn (Book More TV)",
    },
    {
        label: "Scene Study",
        body: "Dana Zeller-Alexis, New York",
    },
    {
        label: "Voice",
        body: "John Komasa · Gillian Kelly · Renata Corisio Booth · Dolores Simonel",
    },
    {
        label: "Movement",
        body: "Physical Theatre — Doug Berky · Stage Combat — Bob Murray · Jazz / Tap",
    },
];

export const SPECIAL_SKILLS = [
    "Singing (Mezzo D3–Bb5)",
    "Standard British dialect",
    "Mid-Atlantic & Southern dialects",
    "NYC dialect",
    "Puppetry",
    "Horseback riding",
    "Ear prompter / teleprompter proficient",
    "Rapier · Dagger · Small Sword · Broadsword",
    "Jazz · Tap",
];

export const AWARDS = [
    {
        year: "2018",
        title: "Outstanding Performance by a Lead Actress in a Play",
        org: "Theatre Tampa Bay",
        for: "The Year of Magical Thinking · Stageworks Theatre",
    },
    {
        year: "2016",
        title: "Best Ensemble (Winner) · Outstanding Featured Actress (Nominee)",
        org: "Theatre Tampa Bay",
        for: "Good People · American Stage",
    },
    {
        year: "2017–18",
        title: "Florida Arts Scholarships — Creative Capital Core & Advanced",
        org: "Florida Dept of Cultural Affairs / NEA",
        for: "Citizens for Florida Arts",
    },
];

export const CASTING_LINKS = [
    { label: "IMDb", href: "https://www.imdb.com/", note: "Profile" },
    {
        label: "Actors Access",
        href: "https://www.actorsaccess.com/",
        note: "Casting Profile",
    },
    { label: "Vimeo", href: "https://vimeo.com/", note: "Reel & Clips" },
];
